import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogComponent } from './dialog/components/dialog.component';



@NgModule({
  declarations: [
    DialogComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
  ],
  exports: [
    DialogComponent,
  ],
  entryComponents: [
    DialogComponent,
  ],
})
export class DialogModule { }
